import React from 'react';

export const renderHeaderItem = (column, idx) => {
  const containerProps = {};
  if (column.width) {
    containerProps.style = { width: column.width };
  } else {
    containerProps.className = 'u-flex-1';
  }

  return (
    <div {...containerProps} key={idx}>
      {column.header}
    </div>
  );
};

export const renderRowItem = columns => (item, idx) => (
  <div className="c-info-block__row" key={idx}>
    {
      columns.map((column, columnIdx) => {
        const containerProps = {
          className: 'u-pr--',
        };
        if (column.width) {
          containerProps.style = { width: column.width };
        } else {
          containerProps.className = `${containerProps.className} u-flex-1`;
        }

        return (
          <div {...containerProps} key={columnIdx}>
            {column.cell(item)}
          </div>
        );
      })
    }
  </div>
);
